import { useContext } from 'react';
import { PopoverContext } from '../contexts/PopoverContext';

export const usePopoverContext = () => {
  return useContext(PopoverContext);
};
